export default "__VITE_ASSET__4ce8ba0e__"